
/*
* this file collects all blockers and helper functions for common blocker handling
*
* for example @see blockerToSubmitProposal()
*
* @todo muss kompatibel gemacht werden zu blockersForTransition(), bzw. blockersForTransition() muss einbezogen werden in dieses Blocker-Konzept
*/

import { ChallengeSubmissionBlocker } from "./challengeHelper"
import { ProposalSubmissionBlocker } from "./proposalHelper"

/**
 * list of common blockers for all usecases
 */
export enum CommonBlockers {
  ObjectNotFound = "error:failure.notFound",
  ModuleNotAvailable = "error:failure.moduleNotAvailable",
  ObjectsDoNotMatch = "error:blocker.objectsDoNotMatch"
}

// those blockers are not used yet (NR: 08.08.2023)
export enum PermissionBlockers {
  CoordinatorRequired = "proposal.submit.allowedOnlyForProjectCoordinator"
}

/**
 * type collection of all available blockers
 */
export type AllBlockers =
  CommonBlockers
  | ProposalSubmissionBlocker
  | ChallengeSubmissionBlocker
  | PermissionBlockers


/**
 * blockers and its (future) context
 */
export interface BlockerContext {
  /**
   * list of found blockers within the given context
   */
  blocker: AllBlockers[]
  // there will by more context in future

  // @todo: add functions:
  // getMostImportantBlocker = () => this.blocker[0]
  // addBlocker (newBlockers: BlockerContext) = () => this.blocker = [].concat(this.blocker, newBlockers.blocker)
}

/**
 * @returns true, if a given BlockerContext has at least one blocker
 */
export const hasBlockers = (context: BlockerContext): boolean => context.blocker.length > 0

/**
 * Merges a list of blocker-lists
 * usage: const allBlockers = mergeBlockers(blockersA, blockersB, blockersC)
 *
 * @param blockers a list of blockers
 * @returns the merged blockers
 */
export const mergeBlockers = (...blockers: BlockerContext[]): BlockerContext => {
  const mergedBlockers: BlockerContext = { blocker: [] }
  blockers.forEach(element => {
    mergedBlockers.blocker = [].concat(mergedBlockers.blocker, element.blocker)
  })
  return mergedBlockers
}

// mapped errors to Codes
// export type BlockerToErrorCodeMap = {
//   [code in AllBlockers]: string
// }
